import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import OurStory from "@/pages/OurStory";

export const Route = createFileRoute("/zh-cn/about-qbd/story")({
  head: () => buildRouteHead("/zh-cn/about-qbd/story"),
  component: OurStory,
});

